import { CdkColumnDef } from '@angular/cdk/table';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { GetReserveReleasesResponse } from '@lsq-frontend/remote-services/enterprise/common';
import {
    GetReserveReleasesRequest,
    GetReserveReleasesService
} from '@lsq-frontend/remote-services/enterprise/dashboard-services';
import {
    DateFnsFormat,
    Table,
    DateConstants,
    getRouterLinkById,
    Color
} from '@lsq-frontend/common-ui';
import { Icons, ResponsiveService } from '@lsq-frontend/common-ui';
import { LsqApiServiceListSource } from '@lsq-frontend/angular-shared/api-service';
import { I18n } from '@ngx-translate/i18n-polyfill';
import { format } from 'date-fns';
import {
    IRequestFundsStatusInformation,
    RequestFundsStatus,
    RequestFundsStatusInformation
} from '../../../constants/request-funds-status.constants';
import {
    atlas,
    REPORTS_FUNDINGS,
    REQUEST_FUNDS
} from '@lsq-frontend/fasttrack-shared/routing-atlas';
import { PopoverPlacement } from 'ngx-smart-popover';

@Component({
    selector: 'fund-requests',
    templateUrl: './fund-requests.component.html',
    styleUrls: ['./fund-requests.component.scss'],
    encapsulation: ViewEncapsulation.None,
    providers: [CdkColumnDef]
})
export class FundRequestsComponent implements OnInit {
    public getReserveReleasesDataSource: LsqApiServiceListSource<
        GetReserveReleasesResponse,
        GetReserveReleasesRequest
    >;
    public title = this._i18n({
        value: 'Last 30 Days of Fund Requests',
        meaning: 'Past fund requests table title'
    });
    public isSmBelow$ = this._responsiveService.smBelow;
    public data;

    public submissionDateHeader = this._i18n({
        value: 'Submission Date',
        meaning: 'Table column header'
    });
    public dateRequestedHeader = this._i18n({
        value: 'Date Requested',
        meaning: 'Table column header'
    });
    public dateProcessedHeader = this._i18n({
        value: 'Date Processed',
        meaning: 'Table column header'
    });
    public dateProcessedMobileHeader = this._i18n({
        value: 'Date Processed',
        meaning: 'Table column header'
    });
    public amountRequestedHeader = this._i18n({
        value: 'Amount Requested',
        meaning: 'Table column header'
    });
    public amountRequestedMobileHeader = this._i18n({
        value: 'Amount Requested',
        meaning: 'Table column header'
    });
    public amountFundedHeader = this._i18n({
        value: 'Amount Funded',
        meaning: 'Table column header'
    });
    public amountFundedMobileHeader = this._i18n({
        value: 'Amount Funded',
        meaning: 'Table column header'
    });
    public statusHeader = this._i18n({
        value: 'Status',
        meaning: 'Table column header'
    });
    public routerLinkRequestFunds = getRouterLinkById(atlas, REQUEST_FUNDS);
    public routerLinkAllFundings = getRouterLinkById(atlas, REPORTS_FUNDINGS);
    public readonly noDataTitle = this._i18n('No fund requests to show yet.');
    public tooltipPlacement = PopoverPlacement.Top;
    public tooltipText: string =
        'This includes only requests that you have initiated from the Request Funds page.';
    public icons = Icons;
    public color = Color;

    constructor(
        private _i18n: I18n,
        public _responsiveService: ResponsiveService,
        public getReserveReleasesService: GetReserveReleasesService
    ) {
        const getReserveReleasesInitialRequest = new GetReserveReleasesRequest({
            fromDateFilter: DateConstants.BeginningOfTime,
            toDateFilter: new Date(),
            take: 5,
            skip: 0
        });
        this.getReserveReleasesDataSource = new LsqApiServiceListSource(
            this.getReserveReleasesService,
            getReserveReleasesInitialRequest
        );
        this.getReserveReleasesDataSource.rows$.subscribe((rows) => (this.data = rows));
    }

    public getInfoForStatus(status: string): IRequestFundsStatusInformation {
        return RequestFundsStatusInformation[RequestFundsStatus[status]];
    }

    public getFormattedDateTimeForMobile(dateString: string): string {
        if (dateString && `${dateString}`.length > 0) {
            const shortDate = format(dateString, DateFnsFormat.ShortFormat);
            const time = format(dateString, DateFnsFormat.TimeFormat);
            return `${shortDate}`;
        } else {
            return Table.NullAmount;
        }
    }

    public ngOnInit(): void {}
}
